'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideIn = void 0;
var $ = require("jquery");
var gsap_1 = require("gsap");
var ScrollTrigger_1 = require("gsap/ScrollTrigger");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
var SlideIn = /** @class */ (function () {
    function SlideIn() {
        $(window).on('load scroll', function () {
            var scroll = $(window).scrollTop();
            var browserHeight = $(window).outerHeight();
            $('.bulletAnimation').each(function () {
                var position = $(this).offset().top;
                if (scroll > (position - browserHeight / 1.5)) {
                    $(this).attr('data-active', '1');
                }
            });
        });
        /*gsap.utils.toArray<HTMLElement>('.bulletSlideIn').forEach(element => {
            let start      = 'top bottom';
            const customY  = $(element).attr('data-y') || 100;
            const end_position = $(element).attr('data-end-position') || 'center bottom';

            gsap.set(element, {
                y: customY,
                opacity: 0,
            });

            gsap.to(element, {
                y: 0,
                opacity: 1,
                scrollTrigger: {
                    trigger: element,
                    start: start,
                    end: end_position,
                    scrub: 1
                }
            });
        });*/
    }
    return SlideIn;
}());
exports.SlideIn = SlideIn;
exports.default = SlideIn;
